import { CustomDrawer } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomDrawer)`
  .simplebar-content-wrapper {
    padding: 0 !important;
  }
  .MuiPaper-root {
    padding: 0;
    height: 100%;
  }
  .DrawerContentScrollBar_Content {
    height: 100%;
  }

  &.MuiDrawer-root {
    border: none;
  }

  &.open {
    border-color: ${(p) => p.theme.palette.primary[500]};
  }
`;
